export enum PryAnalyticsEvents {
  SegmentIntegrationTest = 'pry.landing-page.segment-integration.production',
}

type EmptyPayload = Record<string, unknown>;

export type PryEventSchemaMap = {
  [PryAnalyticsEvents.SegmentIntegrationTest]: EmptyPayload;
};
